"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignupDto = instanceOfSignupDto;
exports.SignupDtoFromJSON = SignupDtoFromJSON;
exports.SignupDtoFromJSONTyped = SignupDtoFromJSONTyped;
exports.SignupDtoToJSON = SignupDtoToJSON;
exports.SignupDtoToJSONTyped = SignupDtoToJSONTyped;
/**
 * Check if a given object implements the SignupDto interface.
 */
function instanceOfSignupDto(value) {
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('confirmPassword' in value) || value['confirmPassword'] === undefined)
        return false;
    return true;
}
function SignupDtoFromJSON(json) {
    return SignupDtoFromJSONTyped(json, false);
}
function SignupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fullName': json['fullName'],
        'email': json['email'],
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'propertyAddress': json['propertyAddress'] == null ? undefined : json['propertyAddress'],
        'interests': json['interests'] == null ? undefined : json['interests'],
    };
}
function SignupDtoToJSON(json) {
    return SignupDtoToJSONTyped(json, false);
}
function SignupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'fullName': value['fullName'],
        'email': value['email'],
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'propertyAddress': value['propertyAddress'],
        'interests': value['interests'],
    };
}
